import React from 'react';
import { useDispatch } from 'react-redux';
import { Block, Button } from '../../components';
import { Button as LinkButton } from '../procedures/components/LinkProcedureAmount/styled';
import noAuthorized from '../../../assets/illustrations/no-authorized.svg';
import { Creators as signOutActions } from '../../../domain/useCases/login/signOutUseCase';
import { Container } from './styles';

const DefaultPage = () => {
  const dispatch = useDispatch();
  const openLink = () => {
    const url =
      'https://api.whatsapp.com/send?phone=51960252970&text=Hola%2C%20soy%20alumno%20UTP%20y%20deseo%20hacer%20una%20consulta';
    window.open(url, 'SAE', 'noopener');
  };
  return (
    <Container data-testid="cmp-default-not-roles-view">
      <Block className="illustrationDef">
        <img src={noAuthorized} alt="" />
      </Block>
      <Block className="textDef">
        <div>
          <div style={{ color: 'var(--text-text02)' }}>
            <p className="textBlack">
              Usuario no autorizado{' '}
              {/* Para seguir disfrutando de nuestros servicios{' '} */}
            </p>
            {/* <span>ingresa al “Portal del estudiante”</span> */}
            <span className="textSubtitle">
              Si eres alumno y no puedes ingresar, comunícate con{' '}
              <b>SAE WhatsApp</b>{' '}
              <LinkButton
                data-testid="cmp-link-open-whatsapp"
                onClick={openLink}
              >
                960252970
              </LinkButton>
            </span>
          </div>
        </div>
      </Block>
      <Block className="buttonDef">
        <Button
          value="Cerrar sesión"
          text="Cerrar sesión"
          onClick={() => {
            dispatch(signOutActions.signOut());
          }}
        />
      </Block>
    </Container>
  );
};

export default DefaultPage;
